var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPriorityIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_189_436)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z",
    fill: "#FF2746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 42.5C85 41.1022 84.9304 39.7204 84.7984 38.3573L75.4227 28.8779L73.2423 42.2138L62.5338 41.3552L20.7491 42.5L15.2278 49.2333V42.8815L4.72214 44.8611L12.4646 52.6036L9.56315 56.1083L38.495 84.8107C39.8139 84.9341 41.1491 85 42.5 85C65.9719 85 85 65.972 85 42.5Z",
    fill: "#940030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2777 40.1389H4.72214V44.8611H80.2777V40.1389Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2777 40.1389H42.2624V44.8611H80.2777V40.1389Z",
    fill: "#FFEDB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0555 40.1389H23.6111V44.8611H33.0555V40.1389Z",
    fill: "#FEE187"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3889 40.1389H51.9445V44.8611H61.3889V40.1389Z",
    fill: "#FFC61B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7521 56.6666H10.9293C9.85271 56.6666 8.9798 55.7937 8.9798 54.7171V30.2833C8.9798 29.2066 9.85271 28.3337 10.9293 28.3337H11.7521C12.8287 28.3337 13.7016 29.2066 13.7016 30.2833V54.7171C13.7016 55.7937 12.8287 56.6666 11.7521 56.6666Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9751 56.6666H16.1523C15.0757 56.6666 14.2028 55.7937 14.2028 54.7171V30.2833C14.2028 29.2066 15.0757 28.3337 16.1523 28.3337H16.9751C18.0517 28.3337 18.9246 29.2066 18.9246 30.2833V54.7171C18.9246 55.7937 18.0517 56.6666 16.9751 56.6666Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1266 56.6666H21.3038C20.2272 56.6666 19.3543 55.7937 19.3543 54.7171V30.2833C19.3543 29.2066 20.2272 28.3337 21.3038 28.3337H22.1266C23.2032 28.3337 24.0761 29.2066 24.0761 30.2833V54.7171C24.0763 55.7937 23.2034 56.6666 22.1266 56.6666Z",
    fill: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6966 56.6666H62.8738C61.7972 56.6666 60.9243 55.7937 60.9243 54.7171V30.2833C60.9243 29.2066 61.7972 28.3337 62.8738 28.3337H63.6966C64.7732 28.3337 65.6461 29.2066 65.6461 30.2833V54.7171C65.6461 55.7937 64.7732 56.6666 63.6966 56.6666Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9196 56.6666H68.0968C67.0202 56.6666 66.1473 55.7937 66.1473 54.7171V30.2833C66.1473 29.2066 67.0202 28.3337 68.0968 28.3337H68.9196C69.9962 28.3337 70.8691 29.2066 70.8691 30.2833V54.7171C70.8691 55.7937 69.9962 56.6666 68.9196 56.6666Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.071 56.6666H73.2483C72.1716 56.6666 71.2987 55.7937 71.2987 54.7171V30.2833C71.2987 29.2066 72.1716 28.3337 73.2483 28.3337H74.071C75.1476 28.3337 76.0206 29.2066 76.0206 30.2833V54.7171C76.0206 55.7937 75.1478 56.6666 74.071 56.6666Z",
    fill: "#2B2B2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_189_436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityIcon4);
export default __webpack_public_path__ + "static/media/priority_icon_4.a19bd94f352a1c9a47134b7e05e97a8f.svg";
export { ForwardRef as ReactComponent };